import script from "./QuestTroopAssign.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestTroopAssign.vue?vue&type=script&setup=true&lang=js"

import "./QuestTroopAssign.vue?vue&type=style&index=0&id=28e25e54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e25e54"]])

export default __exports__